/* eslint-disable import/prefer-default-export */
const getUniqueDatesFromAllRows = (rescheduleAvailabilityRows) =>
  rescheduleAvailabilityRows.reduce((allDates, { dates }) => [...new Set([...allDates, ...dates])], []);

const getRowsWithoutGarage = (rescheduleAvailabilityRows) =>
  rescheduleAvailabilityRows.filter((row) => !row.garageId);

const getRowsWithoutDates = (rescheduleAvailabilityRows) =>
  rescheduleAvailabilityRows.filter((row) => !row.dates?.length);

const doesNotHaveDuplicatedGarages = (rescheduleAvailabilityRows) => {
  const allGarageIds = rescheduleAvailabilityRows.map(({ garageId }) => garageId);
  const uniqueGarageIds = [...new Set(allGarageIds)];

  if (allGarageIds.length > uniqueGarageIds.length) return false;

  return true;
};

export const getSubmissionErrors = (rescheduleAvailabilityRows) => {
  const validationChecks = [
    {
      errorMessage: 'Please select at least five unique dates in total.',
      passedValidation: getUniqueDatesFromAllRows(rescheduleAvailabilityRows).length >= 5,
    },
    {
      errorMessage: 'Please select a garage for each row.',
      passedValidation: getRowsWithoutGarage(rescheduleAvailabilityRows).length === 0,
    },
    {
      errorMessage: 'Please add dates for each row.',
      passedValidation: getRowsWithoutDates(rescheduleAvailabilityRows).length === 0,
    },
    {
      errorMessage: 'Please do not select the same garage for multiple rows.',
      passedValidation: doesNotHaveDuplicatedGarages(rescheduleAvailabilityRows),
    },
  ];

  const failedChecks = validationChecks.filter(({ passedValidation }) => !passedValidation);
  return failedChecks;
};
